var _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var SvgSuperchainStarBroken = function SvgSuperchainStarBroken(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_2351_16993)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.6536 9.3716C38.0356 8.97435 38.0242 8.34294 37.6281 7.95975L31.1291 1.67263C30.7414 1.2976 30.1262 1.2976 29.7385 1.67263L22.8743 8.31307C22.6526 8.52753 22.3444 8.62769 22.039 8.58449L12.5825 7.24694C12.0485 7.1714 11.5507 7.53303 11.4575 8.06431L9.80743 17.4712C9.75414 17.775 9.56363 18.0372 9.29116 18.1818L0.854566 22.658C0.378091 22.9108 0.187969 23.496 0.42485 23.9806L4.61913 32.5608C4.75459 32.8379 4.75459 33.1621 4.61913 33.4392L0.42485 42.0194C0.187969 42.504 0.378091 43.0891 0.854566 43.342L9.29116 47.8182C9.56363 47.9628 9.75414 48.225 9.80743 48.5288L11.4575 57.9357C11.5507 58.467 12.0485 58.8286 12.5825 58.7531L22.2177 57.3902C22.4166 57.3621 22.6024 57.2747 22.7509 57.1394L33.543 47.311C34.0059 46.8895 33.972 46.1512 33.4726 45.7738L23.7351 38.4159C23.1617 37.9827 23.2189 37.1041 23.8435 36.7488L37.0451 29.2393C37.6642 28.8871 37.7271 28.0189 37.1652 27.5812L28.3091 20.682C27.841 20.3174 27.7916 19.6277 28.2028 19.2L37.6536 9.3716Z",
    fill: "#FF0420"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_2351_16993)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.8871 7.95285C51.7939 7.42158 51.2962 7.05994 50.7621 7.13548L41.1633 8.49318C40.9419 8.52448 40.7375 8.62906 40.5825 8.7902L30.6798 19.0886C30.2686 19.5163 30.318 20.2059 30.7861 20.5706L39.6422 27.4697C40.2041 27.9075 40.1412 28.7756 39.5221 29.1278L26.3205 36.6374C25.6959 36.9927 25.6388 37.8712 26.2121 38.3044L35.9496 45.6624C36.4491 46.0398 36.4829 46.7781 36.0201 47.1996L25.7877 56.5183C25.3609 56.9069 25.3509 57.575 25.7657 57.9763L32.2155 64.2159C32.6032 64.5909 33.2185 64.5909 33.6061 64.2159L40.4703 57.5755C40.692 57.361 41.0003 57.2609 41.3057 57.304L50.7621 58.6416C51.2962 58.7171 51.7939 58.3555 51.8871 57.8242L53.5372 48.4173C53.5905 48.1135 53.781 47.8513 54.0535 47.7067L62.4901 43.2305C62.9665 42.9777 63.1567 42.3926 62.9198 41.908L58.7255 33.3277C58.59 33.0506 58.59 32.7265 58.7255 32.4494L62.9198 23.8691C63.1567 23.3845 62.9665 22.7994 62.4901 22.5466L54.0535 18.0703C53.781 17.9258 53.5905 17.6636 53.5372 17.3598L51.8871 7.95285Z",
    fill: "#FF0420"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_2351_16993",
    x: 0.322998,
    y: 1.39111,
    width: 37.6099,
    height: 57.3721,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2351_16993"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_2351_16993",
    x: 25.4609,
    y: 7.12549,
    width: 37.5605,
    height: 57.3716,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2351_16993"
  })))));
};
export default SvgSuperchainStarBroken;